<mbs-sidepanel
  [id]="sidepanelId"
  side="right"
  innerContentType="nowrap"
  [isCreate]="false"
  [showDelete]="false"
  [showFooter]="true"
  [loadingData]="loadingData"
  [disabledSave]="'Readonly' | can: 'save'">
  <div
    header-title
    class="mbs-sidepanel_title">
    <div class="mbs-sidepanel_title-name">
      {{ 'mbs-ui:ipWhiteList.title' | i18next }}
    </div>
  </div>
  <div
    *ngIf="!loadingData"
    header-content>
    <div class="mbs-sidepanel_header-description">
      {{ 'mbs-ui:ipWhiteList.currentIp' | i18next: { ip: currentIP } }}
    </div>
  </div>
  <div
    loading-data-title
    class="mbs-sidepanel_title">
    <div class="mbs-sidepanel_title-ico text-success">
      <span class="fa fa-users"></span>
    </div>
    <div class="mbs-sidepanel_title-name">
      {{ 'mbs-ui:ipWhiteList.loading' | i18next }}
    </div>
  </div>

  <ng-container body>
    <header class="mbs-sidepanel_content-header">
      <div class="row justify-content-between align-items-center">
        <div class="col-auto">
          <h2 class="mbs-sidepanel_content-title">
            {{ 'mbs-ui:ipWhiteList.enableIPAllowList' | i18next }}
          </h2>
        </div>
        <div class="col-auto">
          <mbs-switcher
            [id]="'enable-ip-white-list'"
            [(ngModel)]="enabled"
            [disabledSelf]="editIndex > -1"
            (ngModelChange)="handleEnableSettings()"></mbs-switcher>
        </div>
      </div>
    </header>
    <div class="mbs-sidepanel_content-scrolling tab-pane">
      <div class="mbs-form_content">
        <div
          class="mbs-form-group"
          *ngIf="enabled">
          <mbs-alert
            [type]="alertType.info"
            [icon]="true">
            {{ 'mbs-ui:ipWhiteList.enableAlert' | i18next }}
            {{ 'mbs-ui:ipWhiteList.makeSure' | i18next
            }}<a [routerLink]="['/AP/Settings']">{{ 'mbs-ui:ipWhiteList.enabled' | i18next }}.</a>
          </mbs-alert>
        </div>
        <div class="mbs-form-group">
          <form [formGroup]="searchForm">
            <div class="form-row">
              <div class="col-9">
                <mbs-input
                  formControlName="search"
                  [clearButton]="true"
                  (clear)="setData()"
                  (buttonClick)="setData()"
                  (keydown.enter)="setData()"
                  [appendButtons]="[{ type: 'secondary', icon: 'ico ico-Search', id: 'search-in-white-list' }]"
                  [placeholder]="'mbs-ui:ipWhiteList.filterFieldPlaceholder' | i18next"></mbs-input>
              </div>
              <div class="col-3">
                <mbs-button
                  (click)="handleAddNew()"
                  type="primary"
                  [block]="true"
                  [disabled]="editIndex > -1">
                  {{ 'mbs-ui:ipWhiteList.addNew' | i18next }}
                </mbs-button>
              </div>
            </div>
          </form>
        </div>

        <mbs-table
          [headers]="headers"
          [data]="visibleData"
          (sort)="handleSort($event)">
          <ng-template
            mbsTableCell
            let-ips
            let-index="rowIndex">
            <ng-container *ngIf="index !== editIndex">
              <span
                [ngClass]="{
                  'text-danger text-decoration-line-through': ips.state === IPWhiteListState.Delete,
                  'text-primary': [IPWhiteListState.Add, IPWhiteListState.Change].includes(ips.state)
                }">
                {{ ips.description }}
              </span>
            </ng-container>
            <ng-container *ngIf="index === editIndex">
              <mbs-input
                [formControl]="editName"
                [placeholder]="'mbs-ui:ipWhiteList.newRange' | i18next"></mbs-input>
            </ng-container>
          </ng-template>
          <ng-template
            mbsTableCell
            let-ipsRange
            let-index="rowIndex">
            <span
              [ngClass]="{
                'text-danger text-decoration-line-through': ipsRange.state === IPWhiteListState.Delete,
                'text-primary': [IPWhiteListState.Add, IPWhiteListState.Change].includes(ipsRange.state)
              }"
              *ngIf="index !== editIndex">
              <ng-container *ngFor="let ipRaw of ipsRange.ips || []"> {{ ipRaw }}<br /> </ng-container>
              <ng-container *ngFor="let ranges of ipsRange.ipRanges || []"> {{ ranges }}<br /> </ng-container>
            </span>
            <ng-container *ngIf="index === editIndex">
              <mbs-input
                type="textarea"
                [formControl]="editRange"
                [rows]="3"
                [placeholder]="'192.168.1.100,192.168.1.100-192.168.1.150'">
              </mbs-input>
            </ng-container>
          </ng-template>
          <ng-template
            mbsTableCell
            let-ips
            let-index="rowIndex">
            <mbs-group-button
              *ngIf="index !== editIndex"
              [disabled]="!!editModel">
              <mbs-button
                (click)="handleEdit(ips, index)"
                [placement]="'left'"
                container="body"
                [ngbTooltip]="'shared:buttons.edit' | i18next">
                <span class="fa fa-pencil text-primary"></span>
              </mbs-button>
              <mbs-button
                (click)="handleDeleteRange(ips)"
                [placement]="'left'"
                container="body"
                [ngbTooltip]="'shared:buttons.delete' | i18next">
                <span class="fa fa-remove text-danger"></span>
              </mbs-button>
            </mbs-group-button>
            <ng-container *ngIf="index === editIndex">
              <mbs-button
                type="primary"
                (click)="handleEditSave(editModel)"
                [block]="true">
                {{ 'shared:buttons.save' | i18next }}
              </mbs-button>
              <mbs-button
                (click)="editModel.state === IPWhiteListState.Change ? handleEditReset() : handleEditCancel()"
                [block]="true">
                {{ (editModel.state === IPWhiteListState.Change ? 'shared:buttons.reset' : 'shared:buttons.cancel') | i18next }}
              </mbs-button>
            </ng-container>
          </ng-template>
        </mbs-table>
      </div>
    </div>
  </ng-container>
</mbs-sidepanel>
